// Copyright 2022, Imprivata, Inc.  All rights reserved.
import {
 Typography } from 'antd';
import './Name.less';
import { useTranslation } from 'react-i18next';

export interface NameProps {
  givenName?: string;
  surname?: string;
}
const Name = (props: NameProps & { 'data-testid'?: string }) => {
  const { t } = useTranslation();
  const testId = props['data-testid'] || undefined;
  if (props.givenName && props.surname) {
    return (
      <div className="ellipsis justify-center">
        <Typography.Title level={2} className="text-center m-0" data-testid={testId}>
          {props.givenName} {props.surname} 
        </Typography.Title>
      </div>
    );
  }
  if (props.givenName || props.surname) {
    return (
      <div className="ellipsis">
        <Typography.Title className="text-center m-0" data-testid={testId}>
          {props.givenName ?? ''}
          {props.surname ?? ''}
        </Typography.Title>
      </div>
    );
  }
  return (
    <Typography.Title className="text-center m-0" data-testid={testId}>{t('name.-')}</Typography.Title>
  );
};
export default Name;
